/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import PropTypes from "prop-types";
import facebookIcon from "../../assets/imgs/Facebook.svg";
import whatsappIcon from "../../assets/imgs/Whatsapp.svg";
import linkIcon from "../../assets/imgs/Link.svg";
import isMobile from "is-mobile";
import copy from "../../utils/copyToClipbaord";

const SocialSharePanel = ({ shareLink, isVertical, getSharedPlatform }) => {
  const copyShare = () => {
    getSharedPlatform("Copy-Share");
    const textArea = document.createElement("textarea");

    textArea.style.maxHeight = "0px";
    textArea.style.height = "0px";
    textArea.style.opacity = 0;
    textArea.value = shareLink;
    document.body.appendChild(textArea);
    textArea.select(shareLink);
    window.document.execCommand("copy");
    document.body.removeChild(textArea);

    const copyMessage = document.getElementById("copy-message");
    copyMessage.style.display = "flex";
    setTimeout(() => {
      copyMessage.style.display = "none";
    }, 2000);
  };

  const facebookShare = () => {
    if (window.FB) {
      getSharedPlatform("Facebook");
      FB.ui(
        {
          // eslint-disable-line
          method: "share",
          display: "popup",
          href: shareLink
        },
        response => {}
      );
    }
  };

  const whatsappShare = isMobile()
    ? `whatsapp://send?text=Check out this link from myplay ${encodeURIComponent(
        shareLink
      )}`
    : `https://web.whatsapp.com/send?text=Check out this link from myplay ${encodeURIComponent(
        shareLink
      )}`;

  return (
    <div
      className={`socialSharePanel__container ${
        isVertical ? "socialSharePanel__container--is-vertical" : ""
      }`}
    >
      <span className="socialSharePanel__copy-message" id="copy-message">
        Link Copied!
      </span>
      <img
        className="socialSharePanel__share-icon"
        src={linkIcon}
        onClick={copyShare}
      />
      <img
        className="socialSharePanel__share-icon"
        src={facebookIcon}
        onClick={facebookShare}
      />
      <a
        href={whatsappShare}
        onClick={() => getSharedPlatform("WhatsApp")}
        target="_blank"
      >
        <img className="socialSharePanel__share-icon" src={whatsappIcon} />
      </a>
    </div>
  );
};

SocialSharePanel.propTypes = {
  getSharedPlatform: PropTypes.func
};
SocialSharePanel.defaultProps = {
  getSharedPlatform: () => {}
};

export default SocialSharePanel;
